import { safeObject } from "@lib/object"

import { BaseProvider } from "./base.provider"

export class AnalyticProvider extends BaseProvider {
  sendYandexEvent(data: YandexEventParams) {
    const { goal = "reachGoal", value, id = 52677589, params } = data

    // TODO: add interface
    // @ts-ignore
    const { ym } = window
    if (!ym || typeof ym !== "function") return

    ym(id, goal, value, params)
  }

  sendGoogleEvent(params: GoogleEventParams) {
    const { action, category, label, value } = params

    // TODO: add interface
    // @ts-ignore
    const { ga } = window
    if (!ga) return

    ga(
      "send",
      safeObject({
        eventCategory: category,
        eventAction: action,
        hitType: "event",
        eventLabel: label,
        eventValue: value,
      }),
    )
  }
}

interface YandexEventParams {
  goal?: string
  value: unknown
  id?: number | string
  params?: Record<string, string>
}

interface GoogleEventParams {
  action: string
  category: string
  label?: string
  value?: unknown
}
